function FullCaracter() {

    return(
        <div className="caracter">
            <img src="./images/jrpg/photos/fullbody.png" alt="Cédric Guetté" height={"750px"}/>
        </div>
    )
}

export default FullCaracter;
